export default {
  MuiLink: {
    defaultProps: {
      fontFamily: 'Roboto',
      underline: 'none' as 'none' | 'hover' | 'always' | undefined,
    },
  },
}
